import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { FileDownloadService } from 'src/app/shared/service/file-download.service';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { closeOpen } from 'src/app/shared/animations/open-close.animations';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-section',
  templateUrl: './search-section.component.html',
  styleUrls: ['./search-section.component.scss'],
  animations: [closeOpen()]
})
export class SearchSectionComponent implements OnInit, OnDestroy {
  // searchComponentで使用
  @Input() searchSide;
  @Input() searchService: SearchService;
  @Input() id: string;
  @Input() sortParams: object;
  @Input() searchParams: SearchCondition;
  @Input() page; // ページ
  //

  @Output() searching = new EventEmitter<any>();
  @Output() searchFinish = new EventEmitter<any>();

  search_tab = true;
  tag_tab = true;
  private mailIndexDownloadSubscription: Subscription;

  constructor(
    private fileDownloadService: FileDownloadService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    if (this.mailIndexDownloadSubscription) {
      this.mailIndexDownloadSubscription.unsubscribe();
    }
  }

  keepOneOpen(v: boolean) {
    return this.search_tab !== this.tag_tab ? true : !v;
  }

  // メール一覧をCSVダウンロードする
  mailIndexDownloadCSV() {
    const params = { mail_type: this.searchSide };
    this.mailIndexDownloadSubscription = this.fileDownloadService.requestMailsCSV(params).subscribe(
      res => this.toastrService.success('CSVを出力中です。完了しましたら通知アイコンにてお知らせします'),
      error => this.toastrService.error('CSVを出力リクエスト時にエラーが発生しました。お手数ですが、再度お試しください')
    );
  }
}
